import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogData, ConfirmationDialogType } from './models/confirmation-dialog.config';

@Component({
    selector: 'ndt-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    standalone: false
})
export class ConfirmationDialogComponent {
   dialogTypes = ConfirmationDialogType;

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
      private dialogRef: MatDialogRef<ConfirmationDialogComponent>
   ) {}

   onNoClick(): void {
      this.dialogRef.close(false);
   }

   onOkClick(): void {
      this.dialogRef.close(true);
   }

   onYesClick(): void {
      this.dialogRef.close(true);
   }
}
